module.exports = __webpack_public_path__ + "img/6.efe8d7d1.jpg";